module.exports = __webpack_public_path__ + "images/emoji/small_red_triangle_down.535e8b7ff382001e034a.png";